define('baseline/upload',["require", "exports", "../dom"], function (require, exports, dom_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    /* Holds the dropzone html elements */
    var Dropzone = /** @class */ (function () {
        function Dropzone(dropzone) {
            this.content = dropzone.querySelector(".dropzone-content");
            this.hiddenFileInput = dropzone.querySelector(".dropzone-hidden-file-input");
        }
        return Dropzone;
    }());
    // Uploads in progress
    var uploads = [];
    function init() {
        for (var _i = 0, _a = (0, dom_1.q)(".dropzone"); _i < _a.length; _i++) {
            var div = _a[_i];
            var dropzone = new Dropzone(div);
            initDropzone(dropzone);
        }
    }
    exports.init = init;
    function initDropzone(dropzone) {
        // Bind click to hidden file input
        dropzone.content.onclick = function () { return dropzone.hiddenFileInput.click(); };
        // Handle file input
        dropzone.hiddenFileInput.onchange = function () {
            uploadFiles(dropzone, Array.from(dropzone.hiddenFileInput.files));
        };
        // Handle file drag'n'drop
        dropzone.content.addEventListener("dragover", function (evt) {
            this.classList.add("hover");
            evt.preventDefault();
        });
        dropzone.content.addEventListener("dragleave", function (evt) {
            this.classList.remove("hover");
            evt.preventDefault();
        });
        dropzone.content.addEventListener("dragend", function (evt) {
            this.classList.remove("hover");
            evt.preventDefault();
        });
        dropzone.content.addEventListener("drop", function (evt) {
            this.classList.remove("hover");
            evt.preventDefault();
            uploadItems(dropzone, evt.dataTransfer.items);
        });
    }
    /**
     * Upload data transfer item list
     */
    function uploadItems(dropzone, items) {
        for (var _i = 0, _a = Array.from(items); _i < _a.length; _i++) {
            var item = _a[_i];
            uploadEntry(dropzone, item.webkitGetAsEntry());
        }
    }
    /**
     * Upload data transfer entries list
     */
    function uploadEntry(dropzone, entry) {
        if (entry.isFile) {
            entry.file(function (file) { return uploadFiles(dropzone, [file]); });
        }
        else {
            // Recurse directories async
            entry.createReader().readEntries(function (dir) {
                for (var _i = 0, dir_1 = dir; _i < dir_1.length; _i++) {
                    var file = dir_1[_i];
                    uploadEntry(dropzone, file);
                }
            });
        }
    }
    /**
     * Upload a list of files
     */
    function uploadFiles(dropzone, files) {
        // Reset upload UI if all previous files have completed
        var complete = uploads.filter(function (f) { return f.complete; }).length;
        if (complete === uploads.length) {
            // Reset upload UI
            dropzone.content.innerHTML = "";
            uploads.length = 0;
        }
        // Add new files to in-progress uploads
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            var upload = {
                file: file,
                bytesSent: 0,
                complete: false,
                success: false
            };
            uploads.push(upload);
            uploadFile(dropzone, upload);
        }
    }
    /**
     * Upload file and update associated views
     */
    function uploadFile(dropzone, upload) {
        // Create status div
        var div = document.createElement("div");
        div.textContent = upload.file.name;
        var status = document.createElement("span");
        status.innerHTML = "<span class=\"saving\"><span>.</span><span>.</span><span>.</span></span>";
        div.appendChild(status);
        dropzone.content.appendChild(div);
        // POST file
        postFile(upload, function (error, result) {
            upload.complete = true;
            upload.success = !error;
            updateProgress();
            if (!error) {
                // Success
                status.innerHTML = " <span class=\"text-success\">✓</span>";
                // Check if all files have uploaded successfully
                var success = uploads.filter(function (f) { return f.success; }).length;
                if (success === uploads.length) {
                    if (success === 1) {
                        // Goto track page
                        window.location.href = result.trackUrl.replace("https://baseline.ws", "");
                    }
                    else {
                        // Reload this page
                        window.location.reload();
                    }
                }
            }
            else {
                // Failure
                status.innerHTML = " <span class=\"text-danger\">✘</span>" +
                    ("<div class=\"text-danger\">Error: " + error + "</div>");
            }
        });
    }
    /**
     * Update progress ui
     */
    function updateProgress() {
        // Calculate sent and total bytes
        var sent = 0;
        var total = 0;
        for (var _i = 0, uploads_1 = uploads; _i < uploads_1.length; _i++) {
            var upload = uploads_1[_i];
            if (upload.complete) {
                sent += upload.file.size;
            }
            else if (upload.bytesSent) {
                sent += upload.bytesSent;
            }
            total += upload.file.size;
        }
        var percent = (100 * sent / total).toFixed(1);
        // Update UI
        for (var _a = 0, _b = (0, dom_1.q)(".dropzone-progress"); _a < _b.length; _a++) {
            var progress = _b[_a];
            progress.style.width = percent + "%";
        }
    }
    /**
     * POST file to backend server
     * TODO: Promisify
     */
    function postFile(upload, cb) {
        var contentType;
        if (upload.file.name.endsWith(".csv")) {
            contentType = "text/csv";
        }
        else if (upload.file.name.endsWith(".csv.gz")) {
            contentType = "application/gzip";
        }
        else if (upload.file.name.endsWith(".gpx")) {
            contentType = "application/gpx";
        }
        var xhr = new XMLHttpRequest();
        xhr.addEventListener("load", function () {
            if (xhr.status === 200) {
                var result = JSON.parse(xhr.responseText);
                cb(undefined, result);
            }
            else {
                // Upload failed
                var errorMessage = "status " + xhr.status;
                try {
                    var json = JSON.parse(xhr.responseText);
                    if (json.error) {
                        errorMessage = json.error;
                    }
                }
                catch (error) { }
                cb(errorMessage);
            }
        });
        xhr.addEventListener("error", function () { return cb("upload failed"); });
        xhr.addEventListener("abort", function () { return cb("upload failed"); });
        xhr.upload.addEventListener("progress", function (e) {
            upload.bytesSent = e.loaded;
            updateProgress();
        });
        // POST file
        xhr.open("POST", "/tracks", true);
        if (contentType) {
            xhr.setRequestHeader("Content-Type", contentType);
        }
        xhr.send(upload.file);
    }
});
//# sourceMappingURL=/assets/javascripts/baseline/upload.js.map;
